"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListState = void 0;
var react_1 = require("react");
function useListState(initialValue) {
    if (initialValue === void 0) { initialValue = []; }
    var _a = react_1.useState(initialValue), state = _a[0], setState = _a[1];
    var append = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        return setState(function (current) { return __spreadArray(__spreadArray([], current), items); });
    };
    var prepend = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        return setState(function (current) { return __spreadArray(__spreadArray([], items), current); });
    };
    var insert = function (index) {
        var items = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            items[_i - 1] = arguments[_i];
        }
        return setState(function (current) { return __spreadArray(__spreadArray(__spreadArray([], current.slice(0, index)), items), current.slice(index)); });
    };
    var apply = function (fn) {
        return setState(function (current) { return current.map(function (item, index) { return fn(item, index); }); });
    };
    var remove = function () {
        var indices = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            indices[_i] = arguments[_i];
        }
        return setState(function (current) { return current.filter(function (_, index) { return !indices.includes(index); }); });
    };
    var reorder = function (_a) {
        var from = _a.from, to = _a.to;
        return setState(function (current) {
            var cloned = __spreadArray([], current);
            var item = current[from];
            cloned.splice(from, 1);
            cloned.splice(to, 0, item);
            return cloned;
        });
    };
    var setItem = function (index, item) {
        return setState(function (current) {
            var cloned = __spreadArray([], current);
            cloned[index] = item;
            return cloned;
        });
    };
    var setItemProp = function (index, prop, value) {
        return setState(function (current) {
            var _a;
            var cloned = __spreadArray([], current);
            cloned[index] = __assign(__assign({}, cloned[index]), (_a = {}, _a[prop] = value, _a));
            return cloned;
        });
    };
    return [
        state,
        {
            setState: setState,
            append: append,
            prepend: prepend,
            insert: insert,
            apply: apply,
            remove: remove,
            reorder: reorder,
            setItem: setItem,
            setItemProp: setItemProp,
        },
    ];
}
exports.useListState = useListState;
